module.exports = __webpack_public_path__ + "fonts/SFUIText-Bold.bc1fd02a.ttf";